<template>
  <div class="min-h-full dark:bg-gray-950">
    <main>
      <div class="mx-auto max-w-screen-2xl sm:px-6 lg:px-8 dark:bg-gray-950">
        <slot />
      </div>
    </main>
    
    <!-- Global Confirmation Dialog -->
    <ConfirmationDialog />
  </div>
</template>

<script setup lang="ts">
import ConfirmationDialog from '@/components/ui/ConfirmationDialog.vue';

// Main layout component for consistent screen width across the app
// Max width: 7xl (1280px)
// Responsive padding: sm:px-6 lg:px-8
</script>
